import React from 'react';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Download, RefreshCw, FileText, ArrowRight } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { toPersianDigits, formatCurrency } from '../../utils/persian';
export function PolicyDetailsPage() {
  const {
    id
  } = useParams();
  return <CustomerLayout data-id="element-608">
      <div className="space-y-6" data-id="element-609">
        <div className="flex items-center gap-2 text-gray-500 mb-4" data-id="element-610">
          <Link to="/policies" className="hover:text-gray-900" data-id="element-611">
            <ArrowRight className="h-5 w-5" data-id="element-612" />
          </Link>
          <span data-id="element-613">بازگشت به لیست</span>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start gap-4" data-id="element-614">
          <div data-id="element-615">
            <div className="flex items-center gap-3 mb-2" data-id="element-616">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-617">
                بیمه شخص ثالث
              </h1>
              <Badge variant="success" data-id="element-618">فعال</Badge>
            </div>
            <p className="text-gray-500" data-id="element-619">پژو ۲۰۶ - ۱۴۰۲</p>
          </div>
          <div className="flex gap-2" data-id="element-620">
            <Button variant="outline" data-id="element-621">
              <Download className="ml-2 h-4 w-4" data-id="element-622" />
              دانلود بیمه‌نامه
            </Button>
            <Button data-id="element-623">
              <RefreshCw className="ml-2 h-4 w-4" data-id="element-624" />
              تمدید بیمه‌نامه
            </Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-625">
          <div className="md:col-span-2 space-y-6" data-id="element-626">
            <Card data-id="element-627">
              <CardHeader data-id="element-628">
                <CardTitle className="text-lg" data-id="element-629">مشخصات بیمه‌نامه</CardTitle>
              </CardHeader>
              <CardContent data-id="element-630">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-631">
                  <div className="space-y-1" data-id="element-632">
                    <span className="text-sm text-gray-500" data-id="element-633">شرکت بیمه</span>
                    <p className="font-medium" data-id="element-634">بیمه ایران</p>
                  </div>
                  <div className="space-y-1" data-id="element-635">
                    <span className="text-sm text-gray-500" data-id="element-636">
                      شماره بیمه‌نامه
                    </span>
                    <p className="font-medium" data-id="element-637">
                      {toPersianDigits('123456789')}
                    </p>
                  </div>
                  <div className="space-y-1" data-id="element-638">
                    <span className="text-sm text-gray-500" data-id="element-639">تاریخ شروع</span>
                    <p className="font-medium" data-id="element-640">
                      {toPersianDigits('1402/12/29')}
                    </p>
                  </div>
                  <div className="space-y-1" data-id="element-641">
                    <span className="text-sm text-gray-500" data-id="element-642">تاریخ پایان</span>
                    <p className="font-medium" data-id="element-643">
                      {toPersianDigits('1403/12/29')}
                    </p>
                  </div>
                  <div className="space-y-1" data-id="element-644">
                    <span className="text-sm text-gray-500" data-id="element-645">
                      حق بیمه پرداختی
                    </span>
                    <p className="font-medium" data-id="element-646">{formatCurrency(4500000)}</p>
                  </div>
                  <div className="space-y-1" data-id="element-647">
                    <span className="text-sm text-gray-500" data-id="element-648">کد یکتا</span>
                    <p className="font-medium" data-id="element-649">
                      {toPersianDigits('9876543210')}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card data-id="element-650">
              <CardHeader data-id="element-651">
                <CardTitle className="text-lg" data-id="element-652">پوشش‌ها و تعهدات</CardTitle>
              </CardHeader>
              <CardContent data-id="element-653">
                <div className="space-y-4" data-id="element-654">
                  <div className="flex justify-between items-center py-2 border-b last:border-0" data-id="element-655">
                    <span className="text-gray-600" data-id="element-656">تعهد مالی</span>
                    <span className="font-medium" data-id="element-657">
                      {formatCurrency(400000000)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b last:border-0" data-id="element-658">
                    <span className="text-gray-600" data-id="element-659">
                      تعهد جانی (فوت و نقص عضو)
                    </span>
                    <span className="font-medium" data-id="element-660">
                      {formatCurrency(12000000000)}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2 border-b last:border-0" data-id="element-661">
                    <span className="text-gray-600" data-id="element-662">تعهد حوادث راننده</span>
                    <span className="font-medium" data-id="element-663">
                      {formatCurrency(9000000000)}
                    </span>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          <div className="space-y-6" data-id="element-664">
            <Card data-id="element-665">
              <CardHeader data-id="element-666">
                <CardTitle className="text-lg" data-id="element-667">مشخصات خودرو</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-668">
                <div className="flex justify-between" data-id="element-669">
                  <span className="text-gray-500" data-id="element-670">نوع خودرو</span>
                  <span data-id="element-671">سواری</span>
                </div>
                <div className="flex justify-between" data-id="element-672">
                  <span className="text-gray-500" data-id="element-673">مدل</span>
                  <span data-id="element-674">پژو ۲۰۶</span>
                </div>
                <div className="flex justify-between" data-id="element-675">
                  <span className="text-gray-500" data-id="element-676">سال ساخت</span>
                  <span data-id="element-677">{toPersianDigits('1402')}</span>
                </div>
                <div className="flex justify-between" data-id="element-678">
                  <span className="text-gray-500" data-id="element-679">پلاک</span>
                  <span data-id="element-680">{toPersianDigits('۱۲ ب ۳۴۵ ایران ۶۶')}</span>
                </div>
              </CardContent>
            </Card>

            <Card data-id="element-681">
              <CardHeader data-id="element-682">
                <CardTitle className="text-lg" data-id="element-683">خدمات</CardTitle>
              </CardHeader>
              <CardContent className="space-y-3" data-id="element-684">
                <Button variant="outline" className="w-full justify-start" data-id="element-685">
                  <FileText className="ml-2 h-4 w-4" data-id="element-686" />
                  ثبت خسارت جدید
                </Button>
                <Button variant="outline" className="w-full justify-start" data-id="element-687">
                  <RefreshCw className="ml-2 h-4 w-4" data-id="element-688" />
                  درخواست الحاقیه
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </CustomerLayout>;
}